/*!
* Modal magazine
*/

const $body = $('body');
const wrap = '.magazine';
const tabs = '.tabs';
const tabsTitle = '.tabs-title';
const active = '.is-active';
const next = '.icon-arrow-right';
const back = '.icon-arrow-left';
const pageBlock = '.page-pagination__item';
const attrPanel = 'panel';

/**
 * Update item page in list
 * @param number
 * @param currentWrap
 */
let updatePageNumber = (number, currentWrap) => {
	$(pageBlock, currentWrap).html(number);
};

/**
 * Return list length
 * @param currentWrap
 * @returns {number | jQuery}
 */
let getLengthList = (currentWrap) => {
	return $(`${tabs} ${tabsTitle}`, currentWrap).length;
};

/**
 * Sets listens for events
 */
let setUpListens = () => {
	$body.on('click', `${wrap} ${next}`, (e) => {
		let currentWrap = $(e.currentTarget).closest(wrap);
		let panelName = currentWrap.data(attrPanel);
		let nextIndex = $(`${tabs} ${active}`, currentWrap).index() + 1;
		let lengthList = getLengthList(currentWrap);

		if (nextIndex === lengthList) {
			nextIndex = 0;
		}

		$(`#${panelName}${nextIndex}-label`, currentWrap).click();
		updatePageNumber(nextIndex + 1, currentWrap);
	});

	$body.on('click', `${wrap} ${back}`, (e) => {
		let currentWrap = $(e.currentTarget).closest(wrap);
		let panelName = currentWrap.data(attrPanel);
		let backIndex = $(`${tabs} ${active}`, currentWrap).index() - 1;
		let lengthList = getLengthList(currentWrap);

		if (backIndex < 0) {
			backIndex = lengthList - 1;
		}

		$(`#${panelName}${backIndex}-label`, currentWrap).click();
		updatePageNumber(backIndex + 1, currentWrap);
	});
};

/**
 * Init list
 */
let init = () => {
	setUpListens();
};

export {init as initMagazine};
